var _circle, _line, _line2, _line3, _line4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef, memo } from "react";
const SvgBadge28 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 28 28",
    width: 28,
    height: 28,
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 10,
    r: 6
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 18,
    y1: 15,
    x2: 19,
    y2: 24
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 10,
    y1: 15,
    x2: 9,
    y2: 24
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 14,
    y1: 21,
    x2: 19,
    y2: 24
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 14,
    y1: 21,
    x2: 9,
    y2: 24
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgBadge28);
const Memo = /*#__PURE__*/memo(ForwardRef);
export default Memo;